module.exports = __webpack_public_path__ + "308fe40b634e3a36541a3248ab93d66c.jpg";